import { DateStr, DateTimeStr, TimeRange, toDateRange, yesterday } from '@mi-front/core';

/**
 * Default calendar day used by audit station listings (matches, schedules, status).
 */
export function getAuditListingDefaultDate(): DateStr {
  return yesterday() as DateStr;
}

/**
 * Default from/to window for audit station listings: start and end of yesterday
 * in the given timezone.
 */
export function getAuditListingDefaultDateRange(tz: string): TimeRange<DateTimeStr> {
  return toDateRange(getAuditListingDefaultDate(), tz);
}
